<!-- eslint-disable prettier/prettier -->
<div class="scs-container">
	<div class="scs-icon" aria-hidden="true">
		<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="32" cy="32" r="18.5" stroke="currentColor" stroke-width="3" />
			<path
				d="M24 32.5l5.5 6L41 26.5"
				stroke="currentColor"
				stroke-width="3.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>

	<h1 class="scs-title">VERIFICÁ<br />TU CORREO</h1>

	<p class="scs-message">
		Te escribimos a<br />
		<strong class="scs-email">{{ email }}</strong>
	</p>

	<p class="scs-message">
		Revisá tu bandeja de entrada o la carpeta de spam y hacé clic en el enlace que enviamos en ese correo para continuar.
	</p>

	<div class="scs-pill">El enlace es válido por 24 horas.</div>

	<button class="scs-btn" type="button" (click)="goHome()">Ir al inicio de sesión</button>
</div>
